@app.directive 'internationalJoule', (ModalService, utilities, $http, localStorageService, stripeService)->
  restrict: 'E'
  scope: {}
  controller: ($scope) ->
    @params = ModalService.params()

    @close = ->
      ModalService.resolve()

    @encodeForMailto = (text) ->
      utilities.urlSafeString(text)

    @continueToCheckout = =>
      if @params.checkoutUrl
        # For Shopify
        window.location.assign @params.checkoutUrl
      else
        # Current Stripe implementation
        ModalService.resolve()
        stripeService.showCheckout @params.sku, @params.user, @params.isGift, true

    @addToInternationalJouleMailingList = ->
      ModalService.open('login', source: 'buyButton').then =>
        userToken = localStorageService.get('user.token')
        headerParams = { 'Authorization': 'Bearer ' + userToken, "x-csrf-token":undefined }

        $http(
          method: 'POST'
          headers: headerParams
          params: null
          url: '/api/v0/users/international_joule'
        ).success((data, status, headers, config) =>
          @params.type = 'thanks'
        ).error((data, status, headers, config) =>
          @params.type = 'error'
        )

    this

  controllerAs: 'internationalJoule'
  templateUrl: "/assets/templates/modals/internationalJoule/internationalJoule.html"
